export enum TriggerStateValueSwitch {
  OFF = 'OFF',
  ON = 'ON',
}
